import React from "react";
import PropTypes from "prop-types";
import style from "./burger-menu-secondary-header.css";
import SVGIcon from "../../common/svg-icon";

function BurgerMenuSecondaryHeader({ renderText, onClickEvent }) {
    return (
        <table className={style.secondaryMenuHeader}>
            <tbody>
                <tr>
                    <th
                        className={style.menuItemBigChevron}
                        onClick={onClickEvent}
                    >
                        <SVGIcon name="chevron" flip />
                    </th>
                    <th className={style.secondaryTitle}>{renderText}</th>
                </tr>
            </tbody>
        </table>
    );
}

export default BurgerMenuSecondaryHeader;

BurgerMenuSecondaryHeader.propTypes = {
    renderText: PropTypes.string.isRequired,
    onClickEvent: PropTypes.func.isRequired
};

BurgerMenuSecondaryHeader.defaultProps = {
    renderText: ""
};
